import * as React from 'react';
import { DetailsList, DetailsListLayoutMode, SelectionMode, ConstrainMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';

import '../../css/immocom.css';

import { DetailsListLog } from '../List/DetailsListLog';

/*
***************************************************************
 PROPS:
    object journalisation : journal à afficher
    bool isOpen

    void onDismiss() : méthode appelée à la fermeture du panel
***************************************************************
*/

export class FicheJournalisation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            idJournalisation: 0,
            enCoursDeTraitement: false,
        };
    }
    componentDidMount() { }
    componentWillUnmount() { }
    componentDidUpdate() { }

    render() {
        const journalisation = this.props.journalisation;
        return (
            <Panel
                closeButtonAriaLabel="Masquer les détails"
                headerText={"Détails du journal n°" + journalisation.idJournalisation}
                isLightDismiss
                isOpen={this.props.isOpen}
                onDismiss={this.props.onDismiss}
                type={PanelType.extraLarge}
            >
                <DetailsListLog idJournalisation={journalisation.idJournalisation} />
                <MessageBar messageBarType={MessageBarType.info}>Données inscrites dans le journal</MessageBar>
                <DetailsList
                    columns={[
                        { isResizable: true, key: 'key', minWidth: 100, maxWidth: 150, name: 'Clé', onRender: (item) => { return <span>{item}</span> } },
                        { isMultiline: true, isResizable: true, key: 'value', minWidth: 100, name: 'Valeur', onRender: (item) => { return <span>{journalisation[item]}</span> } }
                    ]}
                    constrainMode={ConstrainMode.unconstrained}
                    items={Object.keys(journalisation)}
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={SelectionMode.none}
                />
            </Panel >
        );
    }
}